import getConfig from 'next/config'
const { publicRuntimeConfig, serverRuntimeConfig } = getConfig()
import { convertFiltersToUrlParams } from './helpers'

/* Server Side APIs */
export const getCurrentUserServer = async (cookie, withPerm = false) => {
  try {
    let apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/account/current`
    if (withPerm) {
      apiUrl += '?perms=true'
    }
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })
    if (!response.ok) {
      if (response.status === 401) {
        const error = new Error()
        error.code = 401
        throw error
      }
      throw `getCurrentUserServer failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      return err
    }
    return Error(err)
  }
}

export const getCurrentAmsInfo = async (cookie, fields = []) => {
  try {
    const filterParams = convertFiltersToUrlParams({ fields })
    const apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/account/current/amsUser?${filterParams}`

    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })
    if (!response.ok) {
      throw `getCurrentAmsInfo failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getCurrentAmsInfoWithAmsAuth = async (amsJwt, fields = []) => {
  try {
    const filterParams = convertFiltersToUrlParams({ fields })
    const apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/account/current/amsUser?${filterParams}`

    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'x-ses-jwt': amsJwt
      }
    })
    if (!response.ok) {
      throw `getCurrentAmsInfo failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getManagedTenantAMSInfo = async (cookie, managedTenantID, fields = []) => {
  try {
    const filterParams = convertFiltersToUrlParams({ fields })
    const apiUrl = `${serverRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/account/ams/${managedTenantID}?${filterParams}`

    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })

    if (!response.ok) {
      throw `getManagedTenantAMSInfo failed: ${response.status} ${response.statusText}`
    }

    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getUser = async (cookie, uuid) => {
  try {
    let apiUrl = `${serverRuntimeConfig.adminApiBaseUrl}/api/v1/user/${uuid}`
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })
    if (!response.ok) {
      throw `getUser failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getTenantByUUID = async (cookie, tenantUUID) => {
  try {
    let apiUrl = `${serverRuntimeConfig.adminApiBaseUrl}/api/v1/tenant/${tenantUUID}`
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })
    if (!response.ok) {
      throw `getTenantByUUID failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getUserByUUID = async (cookie, userUUID) => {
  try {
    let apiUrl = `${serverRuntimeConfig.adminApiBaseUrl}/api/v1/user/${userUUID}`
    const response = await fetch(apiUrl, {
      method: 'GET',
      credentials: 'include',
      headers: cookie && { cookie }
    })
    if (!response.ok) {
      throw `getUserByUUID failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

/* Client Side APIs */

export const updateCurrentUser = async (userAccountData) => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/account/current`
    console.log('PUT /api/v1/account/current url:', apiUrl)
    const body = JSON.stringify(userAccountData)
    const response = await fetch(apiUrl, {
      method: 'PUT',
      body: body,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `fetch updateCurrentUser failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    console.log('PUT /api/v1/account/current responseJSON:', responseJSON)
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const updateCurrentB2bUser = async (userAccountData) => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/b2b/user/current`
    const body = JSON.stringify(userAccountData)
    const response = await fetch(apiUrl, {
      method: 'PUT',
      body: body,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `fetch updateCurrentB2bUser failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const getAllUsers = async (apiFilters) => {
  try {
    const filterParams = convertFiltersToUrlParams(apiFilters)
    let apiUrl = `${publicRuntimeConfig.adminApiBaseUrl}/api/v1/users?${filterParams}`
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw `getAllUsers failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    return Error(err)
  }
}

export const getAllTenants = async (apiFilters) => {
  try {
    const filterParams = convertFiltersToUrlParams(apiFilters)
    let apiUrl = `${publicRuntimeConfig.adminApiBaseUrl}/api/v1/tenants?${filterParams}`
    console.log('apiUrl', apiUrl)
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw `getAllTenants failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    return Error(err)
  }
}

export const updateUserByUUID = async (userUUID, userAccountData) => {
  try {
    let apiUrl = `${publicRuntimeConfig.adminApiBaseUrl}/api/v1/user/${userUUID}`
    const body = JSON.stringify(userAccountData)
    const response = await fetch(apiUrl, {
      method: 'PATCH',
      body: body,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `fetch updateUserByUUID failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const updateTenantByUUID = async (tenantUUID, tenantData) => {
  try {
    let apiUrl = `${publicRuntimeConfig.adminApiBaseUrl}/api/v1/tenant/${tenantUUID}`
    const body = JSON.stringify(tenantData)
    const response = await fetch(apiUrl, {
      method: 'PATCH',
      body: body,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `fetch updateTenantByUUID failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const deleteUsers = async (userUUIDs) => {
  try {
    let apiUrl = `${publicRuntimeConfig.adminApiBaseUrl}/api/v1/users/${userUUIDs}`
    const response = await fetch(apiUrl, { method: 'DELETE' })
    if (!response.ok) {
      throw `deleteUsers failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const requestDataDownload = async () => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/privacy/userDataDownload`
    const response = await fetch(apiUrl)
    if (!response.ok) {
      throw `requestDataDownload failed: ${response.status} ${response.statusText}`
    }
    return response
  } catch (err) {
    return Error(err)
  }
}

export const requestDeleteData = async () => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/privacy/userDataDelete`
    const response = await fetch(apiUrl, { method: 'DELETE' })
    if (!response.ok) {
      throw `requestDeleteData failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const requestDeleteSA = async () => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/privacy/userAccountDelete`
    const response = await fetch(apiUrl, { method: 'DELETE' })
    if (!response.ok) {
      throw `requestDeleteSA failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const requesGDPRDelete = async () => {
  try {
    let apiUrl = `${publicRuntimeConfig.tenantsUsersApiBaseUrl}/api/v1/privacy/userAccountDelete`
    const response = await fetch(apiUrl, { method: 'DELETE' })
    if (!response.ok) {
      throw `requestDeleteSA failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    console.log(err)
    return Error(err)
  }
}

export const exportUsers = async (apiFilters) => {
  try {
    const filterParams = convertFiltersToUrlParams(apiFilters, true)
    const apiUrl = `${publicRuntimeConfig.adminApiBaseUrl}/api/v1/export/users?${filterParams}`
    const response = await fetch(apiUrl)

    if (!response.ok) {
      throw `exportUsers failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    return Error(err)
  }
}

export const getUserPreferenceByKey = async (preferenceKey) => {
  try {
    const apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/userPreferences/byKey/${preferenceKey}`
    const response = await fetch(apiUrl)

    if (!response.ok) {
      throw `getUserPreferenceByKey failed: ${response.status} ${response.statusText}`
    }
    const responseJSON = await response.json()
    return responseJSON
  } catch (err) {
    return Error(err)
  }
}

export const updateUserPreferenceByKey = async (data) => {
  try {
    const { preferenceKey, value } = data
    const apiUrl = `${publicRuntimeConfig.userResourcesApiBaseUrl}/api/v1/userPreferences/byKey/${preferenceKey}`
    const body = JSON.stringify({ value })
    const response = await fetch(apiUrl, {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    if (!response.ok) {
      throw `updateUserPreferenceByKey failed: ${response.status} ${response.statusText}`
    }
    return response
  } catch (err) {
    return Error(err)
  }
}
